import { Box, type BoxProps } from '@mui/material';

type EventButtonProps = Pick<BoxProps, 'onClick' | 'children' | 'sx'> & { readonly eventColor: string };

export const EventButton = ({ onClick, eventColor, children, sx }: EventButtonProps) => (
  <Box
    onClick={onClick}
    sx={{
      // eslint-disable-next-line @typescript-eslint/no-misused-spread
      ...sx,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 1,
      width: '100%',
      minHeight: '1.5rem',
      textAlign: 'center',
      background: eventColor,
    }}
  >
    {children}
  </Box>
);
